// Mock/test data generator. Produces fake records as JSON or CSV, fully in the
// browser. Randomness uses the Web Crypto API.

const FIRST_NAMES = [
  'Ada',
  'Grace',
  'Alan',
  'Linus',
  'Katherine',
  'Dennis',
  'Barbara',
  'Tim',
  'Margaret',
  'Ken',
  'Radia',
  'Guido',
  'Anita',
  'Bjarne',
  'Sophie',
  'Marcus',
];
const LAST_NAMES = [
  'Lovelace',
  'Hopper',
  'Turing',
  'Torvalds',
  'Johnson',
  'Ritchie',
  'Liskov',
  'Berners-Lee',
  'Hamilton',
  'Thompson',
  'Perlman',
  'van Rossum',
  'Borg',
  'Stroustrup',
];
const CITIES = [
  'London',
  'Berlin',
  'Tokyo',
  'Austin',
  'Toronto',
  'Lisbon',
  'Sydney',
  'Oslo',
  'Amsterdam',
  'Seoul',
  'Dublin',
  'Denver',
];
const DOMAINS = ['example.com', 'test.dev', 'mail.co', 'demo.io'];

function randomInt(maxExclusive: number): number {
  if (maxExclusive <= 0) return 0;
  const array = new Uint32Array(1);
  const limit = Math.floor(0xffffffff / maxExclusive) * maxExclusive;
  let value = 0;
  do {
    crypto.getRandomValues(array);
    value = array[0];
  } while (value >= limit);
  return value % maxExclusive;
}

function pick<T>(list: T[]): T {
  return list[randomInt(list.length)];
}

type MockRecord = {
  id: number;
  first_name: string;
  last_name: string;
  email: string;
  city: string;
  age: number;
  active: boolean;
};

function makeRecord(id: number): MockRecord {
  const first = pick(FIRST_NAMES);
  const last = pick(LAST_NAMES);
  const email = `${first}.${last}`.toLowerCase().replace(/[^a-z.]/g, '') + '@' + pick(DOMAINS);
  return {
    id,
    first_name: first,
    last_name: last,
    email,
    city: pick(CITIES),
    age: 18 + randomInt(50),
    active: randomInt(2) === 1,
  };
}

function toCsv(records: MockRecord[]): string {
  const headers = ['id', 'first_name', 'last_name', 'email', 'city', 'age', 'active'];
  const escape = (value: string | number | boolean) => {
    const text = String(value);
    return /[",\n]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
  };
  const rows = records.map((record) =>
    headers.map((header) => escape(record[header as keyof MockRecord])).join(','),
  );
  return [headers.join(','), ...rows].join('\n');
}

export function generateMockData(count: number, format: 'json' | 'csv'): string {
  const total = Math.min(Math.max(Math.floor(count) || 1, 1), 500);
  const records = Array.from({ length: total }, (_, index) => makeRecord(index + 1));
  return format === 'csv' ? toCsv(records) : JSON.stringify(records, null, 2);
}
